export default __webpack_public_path__ + "static/media/nav-arrow.7744681e.svg";